<template>
    <div>
        {{ ip }}
        <zm-dropdown class="btn-contain" style="margin-left: 8px;" trigger="click"
        @command="updateSubscriptionIpListByClick" v-if="hasPermission">
            <zm-button size="small" type="icon" icon="zm-icon-down" class="btn-contain" :loading="loading"></zm-button>
            <zm-dropdown-menu slot="dropdown">
                <zm-dropdown-item
                :command="{ isAdd: true, isAllow: true }"
                v-if="!allowList || allowList.join().indexOf(ip) === -1">
                    add to allow
                </zm-dropdown-item>
                <zm-dropdown-item
                :command="{ isAdd: false, isAllow: true }" v-else>
                    remove from allow
                </zm-dropdown-item>
                <zm-dropdown-item
                :command="{ isAdd: true, isAllow: false }"
                v-if="!denyList || denyList.join().indexOf(ip) === -1">
                    add to deny
                </zm-dropdown-item>
                <zm-dropdown-item
                :command="{ isAdd: false, isAllow: false }" v-else>
                    remove from deny
                </zm-dropdown-item>
            </zm-dropdown-menu>
        </zm-dropdown>
    </div>
</template>
<script>
import { updateSubscriptionIpListByClick } from '../../api/index'
export default {
    name: 'ipcell',
    props: ['group', 'topicId', 'ip', 'isPublic', 'allowList', 'denyList'],
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false
        }
    },
    methods: {
        updateSubscriptionIpListByClick (command) {
            const data = {
                group: this.group,
                topicId: this.topicId,
                ip: this.ip,
                isPublic: this.isPublic,
                isAdd: command.isAdd,
                isAllow: command.isAllow
            }
            this.loading = true
            updateSubscriptionIpListByClick(data).then(response => {
                this.$emit('refresh')
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
